import React from 'react';
import { Container } from 'react-bootstrap';
// import './interest-rate-policy.css'; // optional for custom styles
import './terms-conditions.css'

const InterestRatePolicy = () => {
  return (
    <div className="tc-container">
      <header className="tc-header mb-3">
        <h1>Interest Rate Policy</h1>
      </header>

      <section className="tc-content mb-3">

        <h5> <b>DATTA FINANCE AND TRADING PRIVATE LIMITED </b> </h5>
        
       <h2>Preface</h2>
       <p>The Reserve Bank of India (RBI) vide its Notification No. DNBS. 204 / CGM (ASR)-2009 dated 2 January 2009 and vide its Guidelines on Fair Practices Code for NBFCs, as amended from time to time (RBI Regulations), to be adopted by all Non-banking financial Company(NBFCs), while doing lending business, which also include provisions in relation to charging of interest rates by NBFCs.</p>

       <p>In compliance with the requirements of the RBI Regulations mentioned above and the Fair Practices Code adopted by the Company, the Company has adopted this Interest Rate Policy broadly outlining the Interest Rate Model and the Company’s approach of risk gradation in this regard for its lending business.</p>

       <h4 className="fw-bold">I. Interest Rate Model</h4>
      <p>
        The business model of Datta Finance and Trading Private Limited (DFTPL) focuses on providing credit only to customers meeting the credit standards of DFTPL for varying tenors. The interest rate applicable to each loan account, within the applicable range is assessed on a case specific basis, based on evaluation of various factors detailed below:
      </p>

      <p><strong>a. Tenor of the Loan & Payment Terms -</strong><br />
        term of the loan; terms of payment of interest (viz monthly, quarterly, yearly repayment); terms of repayment of principal; moratorium period, bullet payment, back ended payment schedule, zero coupon structured loans, etc.
      </p>

      <p><strong>b. Internal and External Costs of Funds -</strong><br />
        the rate at which the funds necessary to provide loan facilities to customers are sourced, normally referred to as our external cost of funds. Internal cost of funds being the expected return on equity; is also a relevant factor.
      </p>

      <p><strong>c. Internal cost loading -</strong><br />
        the costs of doing business. Factors such as the complexity of the transaction, capital risk weightage, the size of the transaction, location of the borrower and other factors that affect the costs associated with a particular transaction would be taken into account before arriving at the final interest rate quoted to a customer.
      </p>

      <p><strong>d. Credit Risk -</strong><br />
        as a matter of prudence, credit loss (risk) cost would be factored into all transactions. The amount of credit risk cost applicable to a particular transaction depends on the internal assessment of the credit strength of the customer.
      </p>

      <p><strong>e. Structuring Premium -</strong><br />
        A premium may be applied to a loan in case the loan has any significant structuring elements with respect to collateral, or other aspects of transaction structure.
      </p>

      <p><strong>f. Margin -</strong><br />
        A markup to reflect other costs/overheads to be charged to the loan and our designed margin.
      </p>

      <p><strong>g. Board View & Market Dynamics -</strong><br />
        Views of the Board of Directors on product pricing with respect to prevailing interest rates offered by peer NBFCs for similar products/services shall be taken into consideration. The forecasts and analysis of ‘what if’ scenarios conducted by the Board of Directors are also relevant factors for determining interest rates to be charged.
      </p>

      <p><strong>h. Other Factors -</strong><br />
        Matching tenor cost, market liquidity, RBI Policies on credit flow, offerings by competition, stability in earnings and employment, subvention and subsidies available, deviations permitted, further business opportunities, external ratings, industry trends, switchover options will also be relevant factors in determining interest rate to be charged.
      </p>

      <h4 className="fw-bold">II. Approach for Gradation of Risk</h4>
      <p>The risk premium attached with a customer shall be assessed inter-alia based on the following factors:</p>
      <p>
        a. Profile and market reputation of the borrower
        <br /> b. Inherent nature of the product
        <br /> c. Past repayment track record
        <br /> d. Group strength and repayment capacity
        <br /> e. Nature and value of collateral/security
        <br /> f. Type of asset being financed
        <br /> g. Interest and default risk in segment
        <br /> h. Regulatory stipulations
        <br /> i. and any other factors that may be relevant in a particular case.
      </p>

<h4 className="fw-bold">III. Rate of Interest</h4>

      <p><strong>a.</strong> Interest rates offered could be on fixed rate basis or floating/variable rate basis</p>

      <p><strong>b.</strong> In case of floating/variable interest rates, the interest rates will be benchmarked as under:</p>
      
      <p className="ms-4">
        <strong>Loans under SME Credit Segment:</strong> To Datta Finance And Trading Private Limited Prime Lending Rate (DFTPL-PLR).
      </p>
      <p className="ms-4">
        <strong>Loans under NBFC/LAP/CORPORATE CREDIT:</strong> to DFTPL-PLR or to a market linked transparent benchmark, including reference rate of our bankers as maybe agreed with the borrower.
      </p>
      <p className="ms-4">
        <strong>Loans under Personal Loan Category:</strong> to DFTPL-PLR or to a market linked transparent benchmark, including reference rate of our bankers as maybe agreed with the borrower.
      </p>

      <p><strong>c.</strong> The DFTPL-PLR is an estimation of a benchmark interest rate approved by the Board of Directors of the Company, from time to time. The DFTPL-PLR will be reviewed periodically by the Board of Directors. The estimation and the methodology for calculating the DFTPL-PLR may be changed at any time with the approval of the Board of Directors.</p>

      <p><strong>d.</strong> The rate of interest for the same product and tenor availed during same period by different customers need not be standardized. The final lending rate applicable to each customer will be assessed based on various factors as detailed in this Policy</p>

      <p><strong>e.</strong> Loan amount, Annualized Rate of Interest and tenure of loan will be communicated to the borrower in the sanction letter and the apportionment of installments towards interest and principal dues shall be made available to the borrower.</p>

      <p><strong>f.</strong> Besides normal Interest, the Company may levy additional interest for ad hoc facilities, penal interest/default interest for any delay or default in making payments of any dues. The details of Penal Interest charges for late repayment will be mentioned in bold in the loan agreement and communicated in the sanction letter.</p>

      <p><strong>g.</strong> Besides interest, other financial charges like processing charges, cheque bouncing charges, prepayment/foreclosure charges, part disbursement charges, cheque swaps, cash handling charges, RTGS/other remittance charges, commitment fees, charges on various other services like issuing No Due Certificates, NOC, letters ceding charge on assets/security, security swap & exchange charges etc. would be levied by the company wherever considered necessary. In addition, the Goods and Services Tax and other taxes, levies or cess would be collected at applicable rates from time to time.</p>

      <p><strong>h.</strong> These charges would be proposed by the respective Credit Team(s) of Corporate and SME Segment of the Company’s business and decided in consultation with the Credit Team with the approval by the Board of Directors.</p>

      <p><strong>i.</strong> The rate of interest applicable to each customer is subject to change as the situation warrants and is subject to the management’s perceived risk on a case to case basis.</p>

      <p><strong>j.</strong> Changes in interest rates would be decided at any periodicity, depending upon change in benchmark rate, market volatility and competitor review.</p>

      <p><strong>k.</strong> Intimation of change of interest or other charges would be communicated to customers in a manner deemed fit, as per terms of the loan documents. Any revision in interest or other charges would be with prospective effect.</p>

      <p><strong>l.</strong> Claims for refund or waiver of charges/penal interest/additional interest would normally not be entertained by the Company. It is the sole and absolute discretion of the Company to deal with such requests, if any.</p>

      </section>
    </div>
  );
};

export default InterestRatePolicy;
